import { useState, type FormEvent } from 'react';
import { api } from '../lib/api';
import { useAsync } from '../lib/useAsync';

export function Staff() {
  const staff = useAsync(() => api.staff.list(), []);
  const orgs = useAsync(() => api.orgs.list(), []);
  const [form, setForm] = useState({ email: '', name: '', isPlatformAdmin: false, orgId: '', role: 'editor' });
  const [error, setError] = useState('');

  async function create(e: FormEvent) {
    e.preventDefault();
    setError('');
    try {
      await api.staff.create({ email: form.email, name: form.name || null, isPlatformAdmin: form.isPlatformAdmin, orgId: form.orgId || null, role: form.orgId ? form.role : null });
      setForm({ email: '', name: '', isPlatformAdmin: false, orgId: '', role: 'editor' });
      staff.reload();
    } catch (err) { setError((err as Error).message); }
  }

  return (
    <>
      <h1>Staff</h1>
      <form onSubmit={create} className="card stack" style={{ marginBottom: '1rem' }}>
        <div className="row">
          <div style={{ flex: 2 }}><label>Email</label><input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} /></div>
          <div style={{ flex: 1 }}><label>Name</label><input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} /></div>
        </div>
        <div className="row">
          <div style={{ flex: 1 }}><label>Org</label>
            <select value={form.orgId} onChange={(e) => setForm({ ...form, orgId: e.target.value })}>
              <option value="">— none (platform admin only) —</option>
              {orgs.data?.map((o) => <option key={o.id} value={o.id}>{o.name}</option>)}
            </select>
          </div>
          <div style={{ flex: 1 }}><label>Role</label>
            <select value={form.role} disabled={!form.orgId} onChange={(e) => setForm({ ...form, role: e.target.value })}>
              <option value="owner">owner (edits, sees fan emails)</option>
              <option value="editor">editor</option>
              <option value="viewer">viewer</option>
            </select>
          </div>
          <label style={{ alignSelf: 'end', fontWeight: 500 }}><input type="checkbox" style={{ width: 'auto', marginRight: 6 }} checked={form.isPlatformAdmin} onChange={(e) => setForm({ ...form, isPlatformAdmin: e.target.checked })} />Platform admin</label>
        </div>
        <div className="row"><button className="primary">Add staff</button>{error && <span className="err">{error}</span>}</div>
      </form>
      {staff.error && <p className="err">{staff.error}</p>}
      {staff.data && (
        <table>
          <thead><tr><th>Email</th><th>Name</th><th>Access</th></tr></thead>
          <tbody>
            {staff.data.map((s) => (
              <tr key={s.id}>
                <td>{s.email}</td>
                <td>{s.name ?? <span className="muted">—</span>}</td>
                <td>{s.isPlatformAdmin ? <span className="pill published">platform admin</span> : s.memberships.map((m) => <span className="pill" key={m.orgId} style={{ marginRight: 4 }}>{m.orgName} · {m.role}</span>)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </>
  );
}
